import pino from 'pino'

function createLogger() {
  let datadogAppId = 'unknown'
  let logLevel = 'info'

  try {
    const config = useRuntimeConfig()
    datadogAppId = config?.public?.DATADOG_APP_ID || process.env.DATADOG_APP_ID || 'unknown'
    logLevel = process.env.LOG_LEVEL || 'info'
  } catch {
    // Fallback to process.env if useRuntimeConfig is not available
    datadogAppId = process.env.DATADOG_APP_ID || 'unknown'
    logLevel = process.env.LOG_LEVEL || 'info'
  }

  return pino({
    level: logLevel,
    messageKey: 'message',
    formatters: {
      level: label => ({ level: label.toUpperCase() })
    },
    timestamp: pino.stdTimeFunctions.isoTime,
    base: {
      ddsource: 'nuxt',
      app_id: datadogAppId
    },
    // Redact sensitive data
    redact: {
      paths: [
        'req.headers.authorization',
        'req.headers.cookie',
        'res.headers.setCookie',
        'error.config.headers.cookie',
        'req.body',
        'res.body'
      ],
      censor: '***REDACTED***'
    }
  })
}

const logger = createLogger()

export default logger
